import AntdPopover          from 'antd/lib/popover';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React                from 'react';

export type PopoverProps = {
	arrow?: boolean;
	className?: string;
	children: React.ReactNode;
	title?: React.ReactNode;
	content?: React.ReactNode;
	trigger?: 'hover' | 'focus' | 'click';
	placement?: TooltipPlacement;
	open?: boolean;
	onOpenChange?: (newOpen: boolean) => void;
	color?: string;
	styles?: Partial<Record<'root' | 'body', React.CSSProperties>>;
	/** `shiftX` / `shiftY` décalent le panneau pour le garder dans l'écran, là où `adjustX` / `adjustY` ne savent que le retourner. */
	autoAdjustOverflow?: boolean | { adjustX?: boolean; adjustY?: boolean; shiftX?: boolean; shiftY?: boolean };
}

const Popover = React.forwardRef<any, PopoverProps>((props, ref) => {
	const child = React.isValidElement(props.children)
		? React.cloneElement(props.children as React.ReactElement, { ref } as any)
		: props.children;

	return (
		<AntdPopover
			classNames={{
				root: 'widesk-popover',
				body: props.className,
			}}
			arrow={props.arrow}
			trigger={props.trigger}
			title={props.title}
			content={props.content}
			placement={props.placement}
			open={props.open}
			onOpenChange={props.onOpenChange}
			color={props.color}
			styles={props.styles}
			autoAdjustOverflow={props.autoAdjustOverflow as React.ComponentProps<typeof AntdPopover>['autoAdjustOverflow']}
		>
			{child}
		</AntdPopover>
	);
});

export default Popover;
